// @generated by protobuf-ts 2.9.6 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/content_report.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { PageDomain_Domain } from "./page_domain";
import { ModerationItemType } from "../../../../enums/moderation/moderation_item_type";
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ContentReport
 */
export interface ContentReport {
    /**
     * @generated from protobuf field: optional string item_id = 1;
     */
    itemId?: string;
    /**
     * @generated from protobuf field: optional string reason = 2;
     */
    reason?: string;
    /**
     * @generated from protobuf field: optional string sub_reason = 3;
     */
    subReason?: string;
    /**
     * @generated from protobuf field: optional string comment = 4;
     */
    comment?: string;
    /**
     * @generated from protobuf field: optional string cj_report_id = 5;
     */
    cjReportId?: string;
    /**
     * @generated from protobuf field: optional string action_id = 6;
     */
    actionId?: string;
    /**
     * @generated from protobuf field: bianka.enums.moderation.ModerationItemType item_type = 7;
     */
    itemType: ModerationItemType;
    /**
     * @generated from protobuf field: optional bianka.event.activity.v2.extension.PageDomain.Domain domain = 8;
     */
    domain?: PageDomain_Domain;
    /**
     * @generated from protobuf field: optional string sub_group = 9;
     */
    subGroup?: string;
    /**
     * Stringified array of reported components
     * We can't use repeated here since type in BQ is string
     *
     * @generated from protobuf field: optional string cj_reported_component = 10;
     */
    cjReportedComponent?: string;
    /**
     * @generated from protobuf field: optional bool cj_report_is_anonymous = 11;
     */
    cjReportIsAnonymous?: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class ContentReport$Type extends MessageType<ContentReport> {
    constructor() {
        super("bianka.event.activity.v2.extension.ContentReport", [
            { no: 1, name: "item_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "bianka.core.extension.required": true } },
            { no: 2, name: "reason", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "sub_reason", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "comment", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "cj_report_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "action_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "item_type", kind: "enum", T: () => ["bianka.enums.moderation.ModerationItemType", ModerationItemType, "MODERATION_ITEM_TYPE_"], options: { "bianka.core.extension.required": true } },
            { no: 8, name: "domain", kind: "message", T: () => PageDomain_Domain },
            { no: 9, name: "sub_group", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "cj_reported_component", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "cj_report_is_anonymous", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ], { "bianka.core.extension.enrichment": { groupName: "event_ng" } });
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ContentReport
 */
export const ContentReport = new ContentReport$Type();
